import { Pipe, PipeTransform } from '@angular/core';
import { getFlavor } from '../core/utils';

@Pipe({
  name: 'withFlavor',
  pure: true,
  standalone: true,
})
export class WithFlavorPipe implements PipeTransform {
  private readonly flavor = getFlavor();

  public transform(value: unknown): string {
    return String(value) + '.' + this.flavor;
  }
}
